// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from './styles';
import messages from './intl';

const FilterHeader = () => [
    <FormattedMessage key="title" {...messages.title}>
        {m => <Heading>{m}</Heading>}
    </FormattedMessage>,
    <FormattedMessage key="body" {...messages.body}>
        {m => <p>{m}</p>}
    </FormattedMessage>
];

export default FilterHeader;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/header/index.js